export const convertTextToParameter = (text: string) => {
  const unaccentedText = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  const formattedText = unaccentedText.toLowerCase().trim()
  const param = formattedText.replace(/\s+/g, '-')

  return param
}
